export const SKELETON_PROPS = {
  wrapperClassName: 'absolute w-full h-full top-0 left-0',
  className: 'leading-unset',
  height: '100%',
};
